import useSwitchState from '@anm/hooks/useSwitchState';
import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { subscriptionActions, subscriptionSelectors } from '../../../store/modules/subscription';

export const useEditCardModalControls = () => {
  const [isEditCreditCardOpen, openEditCreditCard, closeEditCreditCard] = useSwitchState();

  const isCardSuccessUpdated = useSelector(subscriptionSelectors.selectUpdateCardData);

  useEffect(() => {
    isCardSuccessUpdated && closeEditCreditCard();
  }, [isCardSuccessUpdated]);

  return [isEditCreditCardOpen, openEditCreditCard, closeEditCreditCard] as const;
};

export const useDeleteCard = () => {
  const dispatch = useDispatch();
  const handler = useCallback(() => {
    dispatch(subscriptionActions.deleteCard());
  }, []);

  return handler;
};
